module.exports = __webpack_public_path__ + "img/api_img05.6dbbc28e.png";